'use strict';

angular.module('youth').controller('HomeHeroCtrl', ['activities', function (activities) {
  var vm = this;
  vm.activities = activities;
  vm.slickConf = {
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<a href="#" class="slide-dot" data-role="none" role="button" aria-required="false" tabindex="0">' + (i + 1) + '</a>';
    },
    infinite: true,
    //autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    autoplay: true,
    arrows: false,
    pauseOnHover: true,
    swipeToSlide: true
  };
}]);